import { fZip, fZipArg } from '@/utils/fZip'

export default {
  methods: { fZip, fZipArg },
}
